module.exports = __webpack_public_path__ + "static/media/first.15d6b77e.svg";